import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=601f2a4c&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./carousel.vue?vue&type=style&index=1&id=601f2a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601f2a4c",
  null
  
)

export default component.exports